import { useState, useEffect, useRef } from "react";

interface RichTextEditorProps {
  value: string;
  onChange: (content: string) => void;
  className?: string;
  placeholder?: string;
  modules?: any;
  theme?: string;
}

export function RichTextEditor({ 
  value, 
  onChange, 
  className, 
  placeholder,
  modules,
  theme = "snow"
}: RichTextEditorProps) {
  const [mounted, setMounted] = useState(false);
  const QuillRef = useRef<any>(null);

  useEffect(() => {
    // Dynamic import to avoid SSR issues
    import("react-quill-new").then((module) => {
      QuillRef.current = module.default;
      setMounted(true);
    });
  }, []);

  if (!mounted || !QuillRef.current) {
    return (
      <div className={`p-4 border rounded-md min-h-[400px] bg-muted/10 animate-pulse flex items-center justify-center ${className}`}>
        <p className="text-muted-foreground font-medium">Initializing editor...</p>
      </div>
    );
  }

  const ReactQuill = QuillRef.current;

  return (
    <div className={`rich-text-editor-wrapper ${className || ""}`}>
      <ReactQuill
        theme={theme}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
      />
    </div>
  );
}
